var Payment = xClass("QQlightgamePayment")
Payment.prototype.ctor = function () {

}

/**
 * 微信米大师接口错误码转义
 * @param {Number} errCode 错误码
 * @returns {String} 错误信息的中文描述
 * @see https://developers.weixin.qq.com/miniprogram/document/midas-payment/requestMidasPayment.html?t=201812
 * @todo 修改为从strings配置中读取
 */
Payment.prototype.errCodeToMsg = function (errCode) {
    if (typeof errCode == "string") {
        errCode = parseInt(errCode)
    }
    let msg = null;
    switch (errCode) {
        case -1:
            msg = "系统失败";
            break;
        case -2:
            msg = "支付取消";
            break;
        case -3:
            msg = "米大师充值失败"
            break;
        case -4:
            msg = "米大师消耗失败"
            break;
        case -1000:
            msg = "参数错误";
            break;
        default:
            msg = null;
            break;
    }
    return msg;
}
// 获取失败类型
Payment.prototype.getFailType = function (errCode) {
    let fail_type = 1;
    if (errCode == -2){
        fail_type = -1;
    }
    return fail_type;
}

Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    let productId = data.productId

    function onSuccess(resp) {
        let data = resp.data
        let orderId = data.orderId;
        console.log("[################]getinfohttp success")
        let balance = data.balance
        let cash = data.cash
        console.log("[#############]qq pay data "+ JSON.stringify(data))
        if (!balance || balance < cash) {
            // 余额不足，充值
            let payment = {
                prepayId: data.prepayId,
                starCurrency: cash,
                success: function() {
                    successCallback && successCallback({ orderId })
                },
                fail: function ({
                    errMsg,
                    errCode
                }) {
                    let fail_type = self.getFailType(errCode);
                    failCallback({
                        code: errCode,
                        data: errMsg,
                        msg: self.errCodeToMsg(errCode),
                        type: fail_type,//1代表是第三方掉起支付失败
                    })
                }
            }
            cc.log("qq pay", JSON.stringify(payment))
            mini.requestMidasPayment(payment)
        } 
        else 
        {
            // 余额够，不需要充值，直接购买
            //pay()
        }
    }

    function onFail(evt) {
        cc.log("[################]getinfohttp failed" + evt.data)
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.log("[################]getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = QQlightgamePaymentGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        productId: productId,
        zoneId: META.user.serverid,
        openid: META.user.openid,
        sessionid: META.user.sessionid,
        ext: data.ext
    })
}

module.exports = Payment